import React, { useState, useEffect, useMemo } from "react";
import {  useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";

import { ColumnFilter } from "../../components/table/ReactTable/ColumnFilter";
import { Badge } from "react-bootstrap";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { stockManagementActions, masterActions } from "../../../_store";
import StockTable from "../../components/table/ReactTable/StockTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";

const StockManagement = () => {
  const dispatch = useDispatch();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  // #region Reducers ------------------  Reducers --------------------------------
  const categoryDrpList = useSelector((x) => x.master.categoryDrpList);
  const stockList = useSelector((x) => x.stockManagement.stockList);

  const navigate = useNavigate();
  const [viewFilter, setviewFilter] = useState([]);
  const isLoading = useSelector((x) => x.stockManagement.isLoading)
useEffect(() => {
    const stockValues = JSON.parse(localStorage.getItem("stockValues")) || [];
  
    if (stockValues.length > 0 || isLoading) {
      showLoader();
    } else {
      hideLoader();
    }
  }, [isLoading]); // Runs when isLoading changes
  useEffect(() => {
    if (isLoading) {
      hideLoader();
    }
  }, [isLoading]);

  const StockList_COLUMNS = (viewFilter,handleTransaction)=>[
  
    {
      Header: "Product Name",
      Footer: "Product Name",
      accessor: "ProductName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Category Name",
      Footer: "Category Name",
      accessor: "CategoryName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "SKU",
      Footer: "SKU",
      accessor: "SKU",
      justify: "left",
      Filter: ColumnFilter,
     
    },

    {
      Header: "Stock Quantity",
      Footer: "Stock Quantity",
      accessor: "StockQuantityStr",
      fieldType: "commaSeparator",
      justify: "center",
      Filter: ColumnFilter,
    },
   
    {
      Header: "Package Type",
      Footer: "Package Type",
      accessor: "PackageType",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Location",
      Footer: "Location",
      accessor: "Location",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Website",
      Footer: "Website",
      accessor: "Woocommerce",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Stock Status",
      Footer: "Stock Status",
      accessor: "StockStatusName",
      justify: "center",
      Filter: ColumnFilter,
      Cell: ({ value }) => {
        return (
          <>
            <div>
              {value === "In Stock" ? (
                <Badge
                  variant="success"
                  style={{ background: "#48A23F", border: "#48A23F" }}
                >
                  In Stock
                </Badge>
              ) : (
                <Badge
                  variant="danger"
                  style={{ background: "#e42313", border: "#e42313" }}
                >
                  Out of Stock
                </Badge>
              )}
            </div>
          </>
        );
      },
    },
    {
      Header: "",
      Footer: "",
      accessor: "Transaction",
      Filter: ColumnFilter,
      disableFilters: true,
      Cell: ({ row }) => {
        return (
          <>
            {/* <a onClick={handlechanges} title="Transaction History"
                        className="btn btn-primary shadow btn-xs sharp me-1"
                    >
                        <i className="fas fa-exchange-alt"></i>
                    </a> */}

            <div
              onClick={() => handleTransaction(row.original,viewFilter)}
              title="Transaction History"
              className="btn btn-primary shadow btn-xs sharp me-1"
            >
              <i className="fas fa-exchange-alt"></i>
            </div>
          </>
        );
      },
    },
    // {
    //     Header: 'Tran. Period',
    //     Footer: 'Tran. Period',
    //     accessor: 'TranPeriod',
    //     Filter: ColumnFilter,
    // },
    // {
    //     Header: '',
    //     Footer: '',
    //     accessor: '',
    //     disableFilters: true,
    //     Cell: ({ value }) => {
    //         return <>
    //             <div className="d-flex">
    //                 <Link onClick={handlePoupClick} title="Edit"
    //                     className="btn btn-primary shadow btn-xs sharp me-1"
    //                 >
    //                     <i className="fas fa-pen"></i>
    //                 </Link>
    //                 <Link
    //                     className="btn btn-danger shadow btn-xs sharp" title="Delete"
    //                 >
    //                     <i className="fa fa-trash"></i>
    //                 </Link>
    //             </div>
    //         </>

    //     }

    // }
  ];
  const handleGetFilter =(id)=>{
   
    setviewFilter([...id])


  };

  const handleTransaction = (productDetail,viewFilter) => {
    const data = {
      ProductID: productDetail.ProductID,
      ProductName: productDetail.ProductName,
      Location: productDetail.Location,
      WCProductID: productDetail.WCProductID,
      PDWCProductID: productDetail.PDWCProductID,
      IsGemar: productDetail.IsGemar,
      IsPartyDeco: productDetail.IsPartyDeco,
    };
        if (viewFilter?.length > 0) {
        localStorage.setItem(`stockValues`, JSON.stringify(viewFilter));
        
    } else {
        console.log("viewFilter is empty inside the function");
        
    }
    
    navigate("/inventoryHistory", {
      state: data,
    });
  };

const columns = useMemo(() => StockList_COLUMNS(viewFilter, handleTransaction), [viewFilter]);

  //Add data
  const [addFormData, setAddFormData] = useState({
    ProductID: "",
    ProductName: "",
    CategoryID: 0,
    SKU: "",
    CategoryOption: null,
    Location: "",
  });

  const newFormData = { ...addFormData };

  // handle Change function
  const handleChange = (event, name) => {
    event.preventDefault();
    //  const regexString = /^[a-zA-Z\s]*$/;
    // const regexNoSymbol = /^[A-Za-z0-9 ]+$/gm;
    const regexNoSymbol = /^[A-Za-z0-9\b ]+$/gm;
    // const regexNumber = /^[0-9\b]+$/;

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;

    if (fieldValue && fieldValue.trim()) {
      if (fieldName === "ProductID" || fieldName === "SKU") {
        if (fieldValue === "" || regexNoSymbol.test(fieldValue)) {
          newFormData[fieldName] = fieldValue;
        }
      } else {
        newFormData[fieldName] = fieldValue;
      }
    } else {
      newFormData[fieldName] = fieldValue.trim();
    }

    //newFormData[fieldName] = fieldValue;
    setAddFormData(newFormData);
  };

  // handle Dropdown Change function
  const handleDrpChange = (event, title) => {
    newFormData[title] = event.value && parseInt(event.value);
    if (title === "CategoryID") {
      newFormData.CategoryOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    }
    setAddFormData(newFormData);
  };

  const handleClear = () => {
    newFormData.CategoryOption = 0;
    newFormData.ProductID =
      newFormData.ProductName =
      newFormData.SKU =
      newFormData.Location =
        "";
    //CategoryOption: null,

    setAddFormData(newFormData);
      if (viewFilter?.length > 0) {
        localStorage.setItem(`stockValues`, JSON.stringify(viewFilter));
    } else {
        console.log("viewFilter is empty inside the function");
    }
    dispatch(
      stockManagementActions.getStockList({
        ProductID: 0,
        ProductName: "",
        CategoryID: 0,
        SKU: "",
        Location: "",
      })
    );
  };

  const handleSearch = () => {
    let ProductID = newFormData.ProductID;
    let ProductName = newFormData.ProductName;
    let CategoryID = newFormData.CategoryID;
    let SKU = newFormData.SKU;
    let Location = newFormData.Location;

    if (ProductID === "" || ProductID === "" || ProductID === undefined)
      ProductID = 0;
         if (viewFilter.length > 0) {
        localStorage.setItem(`stockValues`, JSON.stringify(viewFilter));
    } else {
        console.log("viewFilter is empty inside the function");
    }
    dispatch(
      stockManagementActions.getStockList({
        ProductID,
        ProductName,
        CategoryID,
        SKU,
        Location,
      })
    );
  };

  useEffect(() => {
    let CategoryID = 0;
    let Status = 0;
    let ProductID = 0;
    let ProductName = "";
    let SKU = "";
    let Location = "";

    dispatch(masterActions.GetCategoryDrpList({ CategoryID, Status }));
    //dispatch(subCategoryActions.getSubCategoryAll());
    dispatch(
      stockManagementActions.getStockList({
        ProductID,
        ProductName,
        CategoryID,
        SKU,
        Location,
      })
    );
  }, [dispatch]);

  return (
    <>
      <PageTitle activeMenu="Stock Management" motherMenu="Inventory" />
        
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Stock Management</h4>
          <div className="float-sm-end">
            {/* <Button className="me-2" variant="danger btn-rounded">
                            <span className="btn-icon-start text-danger">
                                <i className="fa fa-solid fa-file-pdf"></i>
                               

                            </span>
                            PDF
                        </Button>
                        <Button className="me-2" variant="secondary btn-rounded">
                            <span className="btn-icon-start text-secondary">
                               
                                <i className="fa fa-regular fa-file-excel"></i>

                            </span>
                            Excel
                        </Button> */}
            {/* <Button className="me-2" variant="primary btn-rounded"
                            onClick={handlechange}>

                            <span className="btn-icon-start text-primary">
                                <i className="fa fa-plus color-info" />
                            </span>
                            Add
                        </Button> */}
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            {/* <div className="col-md-3 mb-4">
                            <label className="text-black font-w500 filtercss"> Product ID</label>
                            <div className="contact-name">
                                <input type="text"
                                    className={`form-control `}
                                    autoComplete="off"
                                    name="ProductID"
                                    placeholder="Product ID"
                                    value={addFormData.ProductID}
                                    onChange={handleChange}
                                />
                                <span className="validation-text"></span>
                            </div>
                        </div> */}
            <div className="col-md-3 mb-4">
              <label className="text-black font-w500 filtercss">
                Product Name
              </label>
              <div className="contact-name">
                <input
                  type="text"
                  className={`form-control `}
                  onChange={handleChange}
                  autoComplete="off"
                  value={addFormData.ProductName}
                  name="ProductName"
                  placeholder="Product Name"
                />
                <span className="validation-text"></span>
              </div>
            </div>

            <div className="col-md-3 mb-4">
              <label className="text-black font-w500 filtercss">Category</label>
              <div className="contact-name">
                <Select
                  classNamePrefix={"custom_select_css"}
                  name="CategoryID"
                  value={newFormData.CategoryOption}
                  onChange={(event) => handleDrpChange(event, "CategoryID")}
                  options={categoryDrpList}
                />
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <label className="text-black font-w500 filtercss"> SKU</label>
              <div className="contact-name">
                <input
                  type="text"
                  className={`form-control `}
                  autoComplete="off"
                  name="SKU"
                  value={addFormData.SKU}
                  onChange={handleChange}
                  placeholder="SKU"
                />
                <span className="validation-text"></span>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <label className="text-black font-w500 filtercss">Location</label>
              <div className="contact-name">
                <input
                  type="text"
                  className={`form-control `}
                  onChange={handleChange}
                  autoComplete="off"
                  value={addFormData.Location}
                  name="Location"
                  placeholder="Location"
                />
                <span className="validation-text"></span>
              </div>
            </div>
            <div className="text-center">
              <Button
                className="me-2"
                variant="primary btn-rounded"
                onClick={() => handleSearch()}
              >
                Search
              </Button>
              <Button
                className="me-2"
                variant="danger btn-rounded"
                onClick={() => handleClear()}
              >
                Clear
              </Button>
            </div>
          </div>
          <br></br>
          <StockTable columns={columns} data={stockList} getFilterValue={(id)=>handleGetFilter(id)}/>
        </div>
      </div>
     
    </>
  );
};
export default StockManagement;
